<template>
  <div class="advertisement">
    <div class="advertisement_tips">
      <!-- 半流程表单与其他表单共用统一的反诈提示口径。 -->
      本平台不会以任何名义向您收取费用，也不会要求您进行转账汇款、提供银行卡密码及短信验证码、缴纳保证金或验证资金等。本平台客服仅使用中国大陆地区电话号码，请勿接听来自中国港澳台地区，以及缅甸、美国等境外国家的陌生来电，谨防诈骗。
    </div>
    <div class="advertisement_tabs">
      <van-tabs v-model="tab_active">
        <van-tab title="平台优势">
          <div class="advertisement_tabs_1">
            <div
              v-for="(item, index) in platform_advantage"
              :key="item.title + index"
              class="advertisement_tabs_item"
            >
              <img class="advertisement_tabs_item_img" :src="item.img" alt="" />
              <h4>{{ item.title }}</h4>
              <span>{{ item.text }}</span>
            </div>
          </div>
        </van-tab>
        <van-tab title="借款步骤">
          <div class="advertisement_tabs_2">
            <div
              v-for="(item, index) in borrowing_steps"
              :key="item.title + index"
              class="advertisement_tabs_item"
            >
              <img
                :class="
                  item.showTit ? 'advertisement_tabs_item_img2' : 'advertisement_tabs_item_arrow'
                "
                :src="item.img"
                alt=""
              />
              <!-- <img v-if="item.showTit" :src="item.img" alt="" /> -->
              <div v-if="item.showTit" class="advertisement_tabs_item_btn">
                {{ item.title }}
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Advertisement',
  data() {
    return {
      tab_active: 0,
      product_name: '产品名称01',
      product_header: '产品副标题',
      platform_advantage: [
        {
          title: '安全保障',
          img: 'https://oss.swiftfintech.com/txfq_cg/h5/icon_safe.png',
          text: '信息安全 多重加密',
        },
        {
          title: '借款灵活',
          img: 'https://oss.swiftfintech.com/txfq_cg/h5/icon_wallet.png',
          text: '更多期限 次日可还',
        },
        {
          title: '专业服务',
          img: 'https://oss.swiftfintech.com/txfq_cg/h5/icon_team.png',
          text: '专业团队 专属服务',
        },
      ],
      borrowing_steps: [
        {
          title: '提交资料',
          img: 'https://oss.swiftfintech.com/txfq_cg/h5/borrowing_step1.png',
          showTit: true,
        },
        {
          title: '',
          img: 'https://oss.swiftfintech.com/txfq_cg/h5/borrowing_arrow.png',
          showTit: false,
        },
        {
          title: '额度审核',
          img: 'https://oss.swiftfintech.com/txfq_cg/h5/borrowing_step2.png',
          showTit: true,
        },
        {
          title: '',
          img: 'https://oss.swiftfintech.com/txfq_cg/h5/borrowing_arrow.png',
          showTit: false,
        },
        {
          title: '放款成功',
          img: 'https://oss.swiftfintech.com/txfq_cg/h5/borrowing_step3.png',
          showTit: true,
        },
      ],
    }
  },
  components: {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.advertisement {
  .advertisement_tips {
    padding: 0.22rem;
    font-size: 0.24rem;
    color: #ff4734;
    background: #feeae8;
    border-radius: 0.2rem;
    text-align: center;
    margin-bottom: 0.3rem;
    line-height: 1.8;
  }
  .advertisement_tabs {
    padding: 0.1rem 0.3rem 0.3rem;
    background-color: #ffffff;
    border-radius: 0.2rem;
    .advertisement_tabs_1,
    .advertisement_tabs_2 {
      margin-top: 0.2rem;
      padding: 0.3rem;
      background: #f4f6ff;
      border-radius: 0.2rem;
      display: flex;
      justify-content: space-between;
      min-height: 106px;
    }
    .advertisement_tabs_item {
      font-size: 0.24rem;
      text-align: center;
      .advertisement_tabs_item_img {
        width: 0.58rem;
      }
      .advertisement_tabs_item_img2 {
        width: 0.68rem;
      }
      > h4 {
        font-size: 0.24rem;
        margin: 0.2rem 0 0;
      }
      > span {
        font-size: 0.2rem;
        color: #7e8499;
      }
      .advertisement_tabs_item_arrow {
        width: 0.56rem;
        margin-top: 0.3rem;
      }
      .advertisement_tabs_item_btn {
        font-size: 0.22rem;
        padding: 0.04rem 0.24rem;
        line-height: 1.5;
        color: #f63728;
        border: 1px solid #f63728;
        border-radius: 0.2rem;
        min-width: 70px;
        margin-top: 0.2rem;
      }
    }
  }
}
</style>
